<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="!loadDone">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CardPopupImg
        :cardContent="content"
        :cardType="cardType"
        :isModalVisible="isShow"
        @popupData2="popupData2"
        :CheckWidth="CheckWidth"
        :score="score"
        :maxscore="maxscore"
        @updateUser="updateUser"
      />
    </template>
  </div>
</template>

<script>
import LoadingMDL from '../../../components/loading/LoadingMDL';
import CardPopupImg from './components/CardPopupImg.vue';
import {mapGetters} from 'vuex';
import '../../../assets/scss/_chineseStyle.scss';
import '../../../assets/scss/_chineseModalCustom.scss';
import TEMPLATE from '../../../TEMPLATE.vue';

export default {
  components: {CardPopupImg, TEMPLATE, LoadingMDL},
  name: 'LKS01',
  data() {
    return {
      code: '',
      lang: '',
      content: {},
      type: '',
      isShow: true,
      cardType: 'score',
      openModalImage: true,
      score: 0,
      CheckWidth: window.innerWidth.toString(),
      maxscore: 0,
      LessonID: 0,
      mode: {},
      assignmentTestScore: {},
      prepostTestScore: {},
      courseSection: '',
      startTime: '',
      courseCode: '',
      condition: [],
      courseSection: '',
      loadDone: false,
      v3Data: {},
    };
  },

  computed: {
    ...mapGetters({
      // allCourse: 'template/getTemplateContent',
      // assignmentTest: 'template/getAssignmentTest',
      // preposttest: 'template/getPrePostTest',
      // getDisplayScore: 'template/getDisplayScore',
      // getUserTemplate: 'template/getUserTemplate',
      getTemplatev3: 'v3/getTemplates',
      saveScoreAndProgress: 'v3/saveScoreAndProgress',
    }),
  },

  watch: {
    getTemplatev3: function (val) {
      if (!val) return;

      this.v3Data = val;
      const template = val.templates[0];
      this.content = template;
      this.navigate = template.navigate;

      if (!template.enable) {
        const pathFormat = template.navigate.close.action.split('-');
        alert('Access denied!');
        this.$router.push(`/v3/${pathFormat[0]}/${pathFormat[1]}`);
      }

      //stamp payload
      const payload = [
        {
          codeItem: this.$store.state.v3.mainCodeItem,
          courseId: this.$store.state.necessary.learningCourse,
          template: this.v3Data.templateID,
          section: this.$store.state.v3.v3EnrollData.data.section,
          content: this.v3Data.content,
          type: this.v3Data.type,
          answering: [], // ถ้าหน้าไหนมีแบบฝึกหัดให้เพิ่มส่วนนี้มาด้วย (ต้องอ้างอิงฟอร์มข้ออันเดิม)
          progress: 100,
          score: 0,
          maxScore: 0,
        },
      ];
      //
      this.$store.dispatch('v3/saveScoreAndProgress', payload);

      //stamp ?
      this.$store.commit('v3/stampMainCodeItem', val.codeItem);
      // this.loadDone = true;
    },
    saveScoreAndProgress: async function (value) {
      console.log('Life cycle...Watch', value);

      if (!value) {
        return console.log(
          'saveScoreAndProgress was call but no data....maybe got called from clearData',
          value
        );
      }

      if (value.length == 0) {
        return console.log('No data is call');
      }

      const scoreData = value[0];
      console.log(scoreData, 'scoreData');

      let userScore = String(scoreData.totalScore).padStart(2, '0');
      let maxScore = String(scoreData.maxScore).padStart(2, '0');
      this.score = userScore;
      this.maxscore = maxScore;
      console.log(this.maxscore, 'max', this.score, 'score');

      //after score complete assign loading = false
      this.loadDone = true;

      // console.log('this.maxScore this.maxScore this.maxScore', this.maxscore);
    },
    // allCourse: function (val) {
    //   if (!val.enable) {
    //     alert('Access denied!');
    //     this.$router.push({name: val.navigate.close.action});
    //   } else {
    //     this.content = val;
    //     let body = {
    //       code: this.courseCode,
    //       template: val._id,
    //     };
    //     this.$store.dispatch('template/fetchScore', body);
    //     this.courseSection =
    //       this.$store.getters['necessary/getUserCourseSection'];
    //     this.$store.dispatch('template/createUserTemplateData', {
    //       code: this.courseCode,
    //       template: val._id,
    //       section: this.courseSection,
    //     });
    //   }
    // },
    // getDisplayScore: function (val) {
    //   console.log('get score on get Display');

    //   this.score = val.totalQuizScore;
    //   this.maxscore = val.maxScore;
    //   this.loadDone = true;
    // },
    // preposttest: function (val) {
    //   this.maxscore = val.fullscore;
    //   if (this.mode.posttestMode == true) {
    //     this.score = val.userscore;
    //   } else if (this.mode.pretestMode == true) {
    //     this.score = val.userscore;
    //   } else {
    //     this.score = this.$store.getters['score/getPoint'];
    //   }
    // },
    // assignmentTest: function (val) {
    //   this.assignmentTestScore = val;
    //   this.maxscore = this.assignmentTestScore.fullscore;
    //   if (this.mode.assingmentmode == true) {
    //     this.score = this.assignmentTestScore.userscore;
    //   } else if (this.mode.testmode == true) {
    //     this.score = this.assignmentTestScore.userscore;
    //   } else {
    //     this.score = this.$store.getters['score/getPoint'];
    //   }
    // },
    //   getUserTemplate: function (val) {
    //     this.condition =
    //       typeof val.data.condition.criteriaType == 'undefined' ||
    //       val.data.condition.criteriaType.length == 0
    //         ? []
    //         : [
    //             {
    //               criteria: val.data.condition.criteriaType[0].criteria._id,
    //               val: val.data.condition.criteriaType[0].val,
    //             },
    //           ];
    //   },
  },

  mounted() {
    this.lang = this.$store.state.language.language;
    // let body = {};
    // body.code = this.courseCode;
    // body.templateCode = `LKS01-` + this.$route.params.id;
    // this.$store.dispatch('template/fetchContent', body);
    this.onLoad();
  },

  created() {},

  beforeDestroy() {},
  methods: {
    onLoad() {
      this.$store.commit('v3/clearScoreAndProgress');
      this.courseCode = this.$store.state.necessary.learningCourse;
      this.startTime = this.$helpers.getDateFormat();
      this.courseSection =
        this.$store.getters['necessary/getUserCourseSection'];
      const contentId = `LKS01-${this.$route.params.id}`;
      this.$store.dispatch('v3/fetchTemplateByCode', contentId);
    },
    checkWidth() {
      if (this.CheckWidth > 800) {
        return 'container-chinese-card';
      } else if (this.CheckWidth <= 800) {
        return 'container-chinese-card-mobile';
      }
      // return "container-chinese-card-mobile"
    },
    popupData2: function (val) {},
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    updateUser() {
      // let body = {
      //   code: this.courseCode,
      //   template: this.content._id,
      //   section: this.courseSection,
      //   startTime: this.startTime,
      //   endTime: this.$helpers.getDateFormat(),
      //   condition: this.condition,
      // };
      // this.$store.dispatch('template/saveUserTemplateData', body);
      //
      const data = [
        {
          codeItem: this.v3Data.codeItem,
          courseId: this.$store.state.necessary.learningCourse,
          template: this.v3Data.templateID,
          section: this.$store.state.v3.v3EnrollData.data.section,
          content: this.v3Data.content,
          type: this.v3Data.type,
          answering: [],
          progress: 100,
          score: 0,
          maxScore: 0,
        },
      ];
      //
      this.$store.dispatch('v3/saveContent', data);
    },
  },
};
</script>
<style></style>
